// document.addEventListener('DOMContentLoaded', function () {
//   const article = document.querySelector('.blog-article-content');
//   const toc = document.querySelector('#blog-toc');

//   if (!article || !toc) return;

//   const headings = article.querySelectorAll('h2, h3');

//   if (!headings.length) {
//     toc.closest('.blog-toc-wrapper')?.remove();
//     return;
//   }

//   const list = document.createElement('ul');

//   headings.forEach(function (heading, index) {
//     if (!heading.id) {
//       heading.id = 'blog-section-' + (index + 1);
//     }

//     const item = document.createElement('li');
//     const link = document.createElement('a');

//     link.href = '#' + heading.id;
//     link.textContent = heading.textContent;

//     if (heading.tagName.toLowerCase() === 'h3') {
//       item.classList.add('toc-subitem');
//     }

//     item.appendChild(link);
//     list.appendChild(item);
//   });

//   toc.appendChild(list);
// });


// document.addEventListener('DOMContentLoaded', function () {

//   const article = document.querySelector('.rr-article-content');

//   if (!article) return;


//   const headings = article.querySelectorAll('h2, h3');

//   if (!headings.length) return;


//   const toc = document.querySelector('#rr-blog-toc');

//   const sidebarToc = document.querySelector('#rr-blog-sidebar-toc');


//   const tocList = document.createElement('ul');

//   const sidebarList = document.createElement('ul');


//   headings.forEach(function (heading, index) {

//     /*
//      * Create unique ID
//      */

//     if (!heading.id) {

//       heading.id = 'rr-section-' + (index + 1);

//     }


//     /*
//      * Main TOC
//      */

//     const item = document.createElement('li');

//     const link = document.createElement('a');

//     link.href = '#' + heading.id;

//     link.textContent = heading.textContent;


//     if (heading.tagName.toLowerCase() === 'h3') {

//       item.classList.add('rr-toc-h3');

//     }


//     item.appendChild(link);

//     tocList.appendChild(item);


//     /*
//      * Sidebar TOC
//      */

//     const sidebarItem = document.createElement('li');

//     const sidebarLink = document.createElement('a');

//     sidebarLink.href = '#' + heading.id;

//     sidebarLink.textContent = heading.textContent;


//     sidebarItem.appendChild(sidebarLink);

//     sidebarList.appendChild(sidebarItem);

//   });


//   if (toc) {

//     toc.appendChild(tocList);

//   }


//   if (sidebarToc) {

//     sidebarToc.appendChild(sidebarList);

//   }


//   /*
//    * Smooth scrolling
//    */

//   document.querySelectorAll(
//     '.rr-blog-toc a, .rr-blog-sidebar-toc a'
//   ).forEach(function (link) {

//     link.addEventListener('click', function (event) {

//       const targetId = this.getAttribute('href');

//       const target = document.querySelector(targetId);

//       if (!target) return;

//       event.preventDefault();

//       target.scrollIntoView({
//         behavior: 'smooth',
//         block: 'start'
//       });

//     });

//   });

// });

document.addEventListener('DOMContentLoaded', function () {

  const article = document.querySelector('.rr-article-content');

  const mainToc = document.querySelector('#rr-blog-toc');

  const sidebarToc = document.querySelector('#rr-blog-sidebar-toc');


  // Stop if article content doesn't exist
  if (!article) {
    console.log('RR Blog TOC: Article content not found');
    return;
  }


  // Find H2 and H3 headings
  const headings = article.querySelectorAll('h2, h3');

  console.log(
    'RR Blog TOC: Headings found:',
    headings.length
  );


  // If there are no headings
  if (!headings.length) {

    const mainWrapper =
      document.querySelector('.rr-blog-toc-wrapper');

    const sidebarCard =
      document.querySelector('.rr-sidebar-toc-card');

    if (mainWrapper) {
      mainWrapper.remove();
    }

    if (sidebarCard) {
      sidebarCard.remove();
    }

    return;
  }


  // Clear existing TOCs
  if (mainToc) {
    mainToc.innerHTML = '';
  }

  if (sidebarToc) {
    sidebarToc.innerHTML = '';
  }


  // Create lists
  const mainList = document.createElement('ul');

  const sidebarList = document.createElement('ul');


  // Build TOC
  headings.forEach(function (heading, index) {

    // Create ID
    if (!heading.id) {

      heading.id =
        'rr-blog-section-' + (index + 1);

    }


    const headingText =
      heading.textContent.trim();


    /*
     * MAIN TOC
     */

    const mainItem =
      document.createElement('li');

    const mainLink =
      document.createElement('a');

    mainLink.href =
      '#' + heading.id;

    mainLink.textContent =
      headingText;


    if (
      heading.tagName.toLowerCase() === 'h3'
    ) {

      mainItem.classList.add(
        'rr-toc-h3'
      );

    }


    mainItem.appendChild(mainLink);

    mainList.appendChild(mainItem);


    /*
     * SIDEBAR TOC
     */

    const sidebarItem =
      document.createElement('li');

    const sidebarLink =
      document.createElement('a');

    sidebarLink.href =
      '#' + heading.id;

    sidebarLink.textContent =
      headingText;


    if (
      heading.tagName.toLowerCase() === 'h3'
    ) {

      sidebarItem.classList.add(
        'rr-toc-h3'
      );

    }


    sidebarItem.appendChild(sidebarLink);

    sidebarList.appendChild(sidebarItem);

  });


  /*
   * Insert MAIN TOC
   */

  if (mainToc) {

    mainToc.appendChild(mainList);

  }


  /*
   * Insert SIDEBAR TOC
   */

  if (sidebarToc) {

    sidebarToc.appendChild(sidebarList);

  }


  /*
   * Smooth scrolling
   */

  document
    .querySelectorAll(
      '.rr-blog-toc a, .rr-blog-sidebar-toc a'
    )
    .forEach(function (link) {

      link.addEventListener(
        'click',
        function (event) {

          const targetId =
            this.getAttribute('href');

          const target =
            document.querySelector(targetId);

          if (!target) {
            return;
          }

          event.preventDefault();

          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        }
      );

    });

});

document.addEventListener('DOMContentLoaded', function () {

  const toggle =
    document.querySelector('.rr-blog-toc-toggle');

  const toc =
    document.querySelector('#rr-blog-toc');

  if (!toggle || !toc) return;


  toggle.addEventListener('click', function () {

    const isOpen =
      toggle.getAttribute('aria-expanded') === 'true';


    if (isOpen) {

      // CLOSE

      toggle.setAttribute(
        'aria-expanded',
        'false'
      );

      toc.hidden = true;

      const icon =
        toggle.querySelector('.rr-blog-toc-icon');

      if (icon) {
        icon.textContent = '+';
      }

    } else {

      // OPEN

      toggle.setAttribute(
        'aria-expanded',
        'true'
      );

      toc.hidden = false;

      const icon =
        toggle.querySelector('.rr-blog-toc-icon');

      if (icon) {
        icon.textContent = '−';
      }

    }

  });

});